import React, {useState} from "react"
import { useNavigate } from 'react-router-dom'
import InputMask from 'react-input-mask'
import {Card, Form, Button} from "react-bootstrap"

// importando a api configurada com as variaveis de ambiente
import api from "../../../../services/api"

const EditarUsuario = ({usuario, setExibirFormEdicao})=>{

    const [userName, setUserName] =  useState(usuario?.userName)
    const [userEmail, setUserEmail] =  useState(usuario?.userEmail)
    const [userPassword, setUserPassword] =  useState("")
    const [userContato, setUserContato] =  useState(usuario?.userContato)
    const [userMatriculaId, setUserMatriculaId] = useState(usuario?.userMatriculaId)

    const navigate = useNavigate()

    function limpaCampos(){
        setUserName("")
        setUserEmail("")
        setUserPassword("")
        setUserContato("")
        setUserMatriculaId("")
    }
    //Faz a conexão via axios para registrar o usuario
    //Depois de registrado redireciona para tela de login
    async function handleUpdate (e){
        
        e.preventDefault()
        console.log("editando ..."+ usuario._id)
        api.put(`/user/${usuario._id}`,{
            userName:userName,
            userEmail:userEmail,
            userContato:userContato,
            userMatriculaId: userMatriculaId
        })
        .then(function (response){
            alert(response.data.message)
            limpaCampos()
            setExibirFormEdicao(false)

        }).catch(function(error){
            console.log(error)         

        }).finally(()=>{
            navigate('/administrador/usuarios')
        })
    }
    async function handleUpdatePassword (e){
        
        e.preventDefault()
        console.log("editando senha")

        api.put(`/user/${usuario._id}/password`,{
            userPassword:userPassword
        })
        .then(function (response){
            console.log(response.data)
            alert(response.data.message)
            limpaCampos()
            setExibirFormEdicao(false)
            navigate('/administrador/usuarios')

        }).catch(function(error){
            alert(error.response?.data?.message || "Não foi possível atualizar a senha.")

        })
    }
    return (
        <>
        <Card>
            <Card.Header className="text-center">
                <Card.Title>Editar Usuário</Card.Title>
            </Card.Header>
            <Card.Body>
                <Form onSubmit={handleUpdate}>
                    <Form.Label>Matrícula ou ID:</Form.Label>
                    <InputMask 
                        disabled
                        required
                        value={userMatriculaId}
                        className="form-control "
                        type="number"
                        onChange={(e)=>{setUserMatriculaId(e.target.value)}}
                        placeholder="Mátricula ou ID"
                        />
                    <br/>
                    <Form.Label>Usuário:</Form.Label>
                    <Form.Control
                        required
                        value={userName}
                        onChange={(e)=>{setUserName(e.target.value)}}
                        placeholder="Nome"/>
                    <br/>
                    
                    <Form.Label>E-mail:</Form.Label>
                    <Form.Control 
                        required
                        value={userEmail}
                        onChange={(e)=>{setUserEmail(e.target.value)}}
                        placeholder="E-mail"/>
                    <br/>
                    <Form.Label>Contato:</Form.Label>
                    <InputMask 
                        required
                        value={userContato}
                        className="form-control "
                        mask="(99) 9 9999-9999"
                        onChange={(e)=>{setUserContato(e.target.value)}}
                        placeholder="(99) 9 0000-0000"
                        />
                    <br/>                  
                    <Button variant="warning" type="submit">
                        Salvar Alteraçoes
                    </Button>
                </Form>
                
            </Card.Body>
        </Card>
        <br/>
        <Card>
        <Card.Header className="text-center">
            <Card.Title>Alterar Senha</Card.Title>
        </Card.Header>
        <Card.Body>
            <Form onSubmit={handleUpdatePassword}>
            
                <Form.Control
                    required
                    placeholder="senha"
                    onChange={(e)=>{setUserPassword(e.target.value)}}
                    type="password"/>
                <br/> 

                <Button variant="warning" type="submit">
                    Confirmar
                </Button>
            </Form>
            
        </Card.Body>
        </Card>
        </>
    )
}
export default EditarUsuario